import * as React from 'react';
import { Formik, FormikErrors, FormikProps, FormikValues } from 'formik';
import { useIntl } from 'react-intl';
import { TInputType } from '../../Forms/Fields/Input';
import LoginInput from '../../Forms/Fields/LoginInput';
import FormikValidatorService, { IInput } from '../../../Services/FormikValidatorService';
import FormikService from '../../../Services/FormikService';
import ModalForm from './ModalForm';
import ActivateAccountService from '../../ActivateAccount/ActivateAccountService';

const RESPONSE_OK = 'ok';
const RESPONSE_ERROR = 'error';

interface IFormProps {
  data: any;
  token: string | null;
}

const Form: React.FC<IFormProps> = (props) => {
  const { formatMessage: f } = useIntl();
  const { data, token } = props;
  const [isButtonLoaderActive, setIsButtonLoaderActive] = React.useState<boolean>(false);
  const [isDone, setIsDone] = React.useState<boolean>(false);
  const [alert, setAlert] = React.useState<any>(null);

  // fields data
  const email = data.filter((i: any) => i.indexId === 'email')[0];
  const password = data.filter((i: any) => i.indexId === 'password')[0];
  const confirmPassword = data.filter((i: any) => i.indexId === 'confirm_password')[0];

  // fields
  const fields: IInput[] = [
    {
      indexId: 'email',
      title: f({ id: 'forgotPassword.email' }),
      type: 'email',
      readonly: false,
      disabled: false,
      value: '',
      placeholder: '',
      rules: email && email.rules ? email.rules : [],
    },
    {
      indexId: 'old_password',
      title: f({ id: 'resetPassword.form.oldPassword' }),
      type: 'password',
      readonly: false,
      disabled: false,
      value: '',
      placeholder: '',
      rules: password && password.rules ? password.rules : [],
    },
    {
      indexId: 'password',
      title: f({ id: 'resetPassword.form.newPassword' }),
      type: 'password',
      readonly: false,
      disabled: false,
      value: '',
      placeholder: '',
      rules: password && password.rules ? password.rules : [],
    },
    {
      indexId: 'confirm_password',
      title: f({ id: 'resetPassword.form.confirmPassword' }),
      type: 'password',
      readonly: false,
      value: '',
      placeholder: '',
      disabled: false,
      rules: confirmPassword && confirmPassword.rules ? confirmPassword.rules : [],
    },
  ];

  // validation
  const handleValidate = (values: FormikValues): FormikErrors<FormikValues> => {
    return FormikValidatorService.validate(values, fields);
  };

  // save
  const save = async (values: FormikValues) => {
    if (token) {
      setIsButtonLoaderActive(true);

      const response: any = await ActivateAccountService.submitForm(
        token,
        values.password,
        values.confirm_password
      );

      if (response && response.status === RESPONSE_OK) {
        setIsDone(true);
      } else if (response && response.status === RESPONSE_ERROR) {
        setAlert({
          title:
            response.form &&
            response.form.validation &&
            response.form.validation.errors &&
            response.form.validation.errors.password
              ? response.form.validation.errors.password[0]
              : response.toast.message,
          message:
            response.form &&
            response.form.validation &&
            response.form.validation.errors &&
            response.form.validation.errors.password
              ? response.form.validation.errors.password[0]
              : response.toast.message,
          type: 'error',
        });
      }
      setIsButtonLoaderActive(false);
    }
  };

  // initial values
  const initialValues = FormikService.setInitialValues(fields);

  // form
  return (
    <Formik initialValues={initialValues} validate={handleValidate} onSubmit={save}>
      {(formikProps: FormikProps<FormikValues>) => (
        <ModalForm
          id="activateaccount-formik-form"
          {...formikProps}
          save={save}
          isButtonLoaderActive={isButtonLoaderActive}
          isDone={isDone}
          alert={alert}
        >
          <LoginInput
            label={fields[0].title}
            id={fields[0].indexId}
            name={fields[0].indexId}
            type={fields[0].type as TInputType}
            placeholder={fields[0].placeholder}
            required={FormikValidatorService.isFieldRequired(fields[0].rules)}
          />
          <LoginInput
            label={fields[1].title}
            id={fields[1].indexId}
            name={fields[1].indexId}
            type={fields[1].type as TInputType}
            placeholder={fields[1].placeholder}
            required={FormikValidatorService.isFieldRequired(fields[1].rules)}
          />
          <LoginInput
            label={fields[2].title}
            id={fields[2].indexId}
            name={fields[2].indexId}
            type={fields[2].type as TInputType}
            placeholder={fields[2].placeholder}
            required={FormikValidatorService.isFieldRequired(fields[2].rules)}
          />
          <LoginInput
            label={fields[3].title}
            id={fields[3].indexId}
            name={fields[3].indexId}
            type={fields[3].type as TInputType}
            placeholder={fields[3].placeholder}
            required={FormikValidatorService.isFieldRequired(fields[3].rules)}
          />
        </ModalForm>
      )}
    </Formik>
  );
};

export default Form;
